module.exports = __webpack_public_path__ + "media/images/shared/border_stripe@2x-b56838d0532feb06390574385271b70a.png";